import { Injectable } from '@angular/core';
import { serviceurl, geoserver_url } from '../constant/constant';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ActiveGameService {

  constructor(
    private http: HttpClient,
  ) { }

  activeGameCharactersDisband(payload){
    return this.http.post<any>(serviceurl + 'api/disband-party/', payload);
  }
}
